import type { Integration } from '../../../types/api';
import { FormField, FormLabel, FormInput } from '../../ui';

interface OpaTabProps {
  integration: Integration | null;
}

function OpaTab({ integration }: OpaTabProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <FormField>
          <FormLabel htmlFor="opa_url">URL OPA</FormLabel>
          <FormInput id="opa_url" name="opa_url" defaultValue={integration?.opa_url} />
        </FormField>

        <FormField>
          <FormLabel htmlFor="opa_token">Token OPA</FormLabel>
          <FormInput
            id="opa_token"
            name="opa_token"
            type="password"
            defaultValue={integration?.opa_token}
          />
        </FormField>
      </div>

      <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 border-b pb-2">
        Configuração SSH
      </h3>

      <div className="grid grid-cols-2 gap-4">
        <FormField>
          <FormLabel htmlFor="opa_ssh_host">SSH Host</FormLabel>
          <FormInput id="opa_ssh_host" name="opa_ssh_host" defaultValue={integration?.opa_ssh_host} />
        </FormField>

        <FormField>
          <FormLabel htmlFor="opa_ssh_port">SSH Porta</FormLabel>
          <FormInput
            type="number"
            id="opa_ssh_port"
            name="opa_ssh_port"
            defaultValue={integration?.opa_ssh_port}
          />
        </FormField>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <FormField>
          <FormLabel htmlFor="opa_ssh_user">SSH Usuário</FormLabel>
          <FormInput id="opa_ssh_user" name="opa_ssh_user" defaultValue={integration?.opa_ssh_user} />
        </FormField>

        <FormField>
          <FormLabel htmlFor="opa_ssh_passwd">SSH Senha</FormLabel>
          <FormInput
            type="password"
            id="opa_ssh_passwd"
            name="opa_ssh_passwd"
            defaultValue={integration?.opa_ssh_passwd}
          />
        </FormField>
      </div>
    </div>
  );
}

export default OpaTab;
